/**
 * Extended HSSelect to add maxItems functionality
 */

const ExistingHSelect = window.HSSelect;

class DialerAIHSelect extends ExistingHSelect {
    constructor(el, options) {
        super(el, options);

        // Get maxItems from data attribute or options
        const data = el.getAttribute('data-select');
        const maxItems = $(el).attr('data-max-items') ? parseInt($(el).attr('data-max-items')) : null;
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };

        this.maxItems = concatOptions?.maxItems || maxItems;
    }

    /**
     * Check if max items limit has been reached
     */
    isMaxItemsReached() {
        if (!this.maxItems || !this.isMultiple) return false;
        return Array.isArray(this.value) && this.value.length >= this.maxItems;
    }

    /**
     * Override buildDropdown to filter options when max items is reached
     */
    buildDropdown() {
        super.buildDropdown();

        // Apply initial filtering if max items already reached
        if (this.isMaxItemsReached()) {
            this.filterOptionsToSelected();
        }
    }

    /**
     * Override searchOptions to filter search results based on selected items when max is reached
     */
    searchOptions(val) {
        // If max items reached, only search within selected items
        if (this.isMaxItemsReached()) {
            this.searchWithinSelected(val);
        } else {
            super.searchOptions(val);
        }
    }

    /**
     * Search only within selected items
     */
    searchWithinSelected(val) {
        if (!this.value || !Array.isArray(this.value)) return;

        const options = this.dropdown.querySelectorAll('[data-value]');
        let hasItems = false;

        options.forEach(el => {
            const dataValue = el.getAttribute('data-value');
            const isSelected = this.value.includes(dataValue);

            // Hide non-selected items
            if (!isSelected) {
                el.classList.add('hidden');
                return;
            }

            // For selected items, apply search filter
            if (val && val.length > this.minSearchLength) {
                const optionVal = el.getAttribute('data-title-value').toLocaleLowerCase();
                const matches = optionVal.includes(val.toLowerCase());

                if (matches) {
                    el.classList.remove('hidden');
                    hasItems = true;
                } else {
                    el.classList.add('hidden');
                }
            } else {
                // No search term, show all selected items
                el.classList.remove('hidden');
                hasItems = true;
            }
        });

        // Handle no results message
        if (this.searchNoResult) {
            this.searchNoResult.remove();
            this.searchNoResult = null;
        }

        if (val && val.length > this.minSearchLength && !hasItems) {
            const htmlToElement = (html) => {
                const template = document.createElement('template');
                html = html.trim();
                template.innerHTML = html;
                return template.content.firstChild;
            };

            const classToClassList = (classes, element) => {
                classes.split(' ').forEach(cls => {
                    if (cls) element.classList.add(cls);
                });
            };

            this.searchNoResult = htmlToElement(this.searchNoResultTemplate);
            this.searchNoResult.innerText = this.searchNoResultText;
            classToClassList(this.searchNoResultClasses, this.searchNoResult);
            this.dropdown.append(this.searchNoResult);
        }
    }

    /**
     * Filter dropdown to show only selected items
     */
    filterOptionsToSelected() {
        if (!this.value || !Array.isArray(this.value)) return;

        const options = this.dropdown.querySelectorAll('[data-value]');
        options.forEach(el => {
            const dataValue = el.getAttribute('data-value');
            if (this.value.includes(dataValue)) {
                el.classList.remove('hidden');
            } else {
                el.classList.add('hidden');
            }
        });
    }

    /**
     * Show all options in dropdown
     */
    showAllOptions() {
        const options = this.dropdown.querySelectorAll('[data-value]');
        options.forEach(el => {
            el.classList.remove('hidden');
        });
    }

    /**
     * Override onSelectOption to handle max items logic
     */
    onSelectOption(val) {
        const wasMaxReached = this.isMaxItemsReached();

        // Call parent implementation
        super.onSelectOption(val);

        const isMaxReached = this.isMaxItemsReached();

        // If we just reached the max, filter to selected items
        if (!wasMaxReached && isMaxReached) {
            this.filterOptionsToSelected();
        }

        // If we just went below the max (deselected an item), show all options
        if (wasMaxReached && !isMaxReached) {
            this.showAllOptions();
            // Re-apply any active search
            if (this.search && this.search.value) {
                super.searchOptions(this.search.value);
            }
        }
    }

    /**
     * Override remoteSearch to handle max items with API data
     */
    async remoteSearch(val) {
        if (this.isMaxItemsReached()) {
            // When max items reached, search only within selected items
            this.searchWithinSelected(val);
        } else {
            // Normal remote search behavior
            await super.remoteSearch(val);
        }
    }
}

function autoInit() {
    if (!window.$hsSelectCollection) {
        window.$hsSelectCollection = []

        window.addEventListener('click', evt => {
            const evtTarget = evt.target

            DialerAIHSelect.closeCurrentlyOpened(evtTarget)
        })
    }

    if (window.$hsSelectCollection) {
        window.$hsSelectCollection = window.$hsSelectCollection.filter(({ element }) => document.contains(element.el))
    }

    document.querySelectorAll('[data-select]:not(.--prevent-on-load-init)').forEach((el) => {
        if (!window.$hsSelectCollection.find(elC => (elC?.element?.el) === el)) {
            const data = el.getAttribute('data-select')
            const options = data ? JSON.parse(data) : {}

            new DialerAIHSelect(el, options)
        }
    })
}

if (typeof window !== 'undefined') {
    window.HSSelect = DialerAIHSelect
    window.HSSelect.autoInit = autoInit;
    window.HSSelect.autoInit();
}

export default DialerAIHSelect;
